import { z } from 'zod'

export const TeamMemberSummarySchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid().nullable().optional(),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  jobTitle: z.string().nullable().optional(),
  department: z.string().nullable().optional(),
})

export type TeamMemberSummary = z.infer<typeof TeamMemberSummarySchema>

export const TeamMemberSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  teamId: z.string().uuid(),
  memberId: z.string().uuid(),
  isPrimary: z.boolean().default(false),
  startDate: z.coerce.date().nullable().optional(),
  endDate: z.coerce.date().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  member: TeamMemberSummarySchema.optional(),
})

export type TeamMember = z.infer<typeof TeamMemberSchema>

export const TeamSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  name: z.string().min(1).max(120),
  description: z.string().nullable().optional(),
  parentTeamId: z.string().uuid().nullable().optional(),
  sortOrder: z.number().int().default(0),
  isActive: z.boolean().default(true),
  settings: z.any().default({}),
  createdBy: z.string().uuid().nullable().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable().optional(),
})

export type Team = z.infer<typeof TeamSchema>

export const TeamWithMembersSchema = TeamSchema.extend({
  members: z.array(TeamMemberSchema).default([]),
  children: z.array(TeamSchema).optional(),
  memberCount: z.number().int().optional(),
})

export type TeamWithMembers = z.infer<typeof TeamWithMembersSchema>

export const CreateTeamSchema = z.object({
  name: z.string().trim().min(1).max(120),
  description: z.string().trim().max(1000).nullable().optional(),
  parentTeamId: z.string().uuid().nullable().optional(),
  sortOrder: z.number().int().optional(),
  isActive: z.boolean().optional(),
  settings: z.any().optional(),
})

export type CreateTeam = z.infer<typeof CreateTeamSchema>

export const UpdateTeamSchema = CreateTeamSchema.partial()

export type UpdateTeam = z.infer<typeof UpdateTeamSchema>

export const AddTeamMemberSchema = z.object({
  memberId: z.string().uuid(),
  isPrimary: z.boolean().optional(),
  startDate: z.coerce.date().nullable().optional(),
  endDate: z.coerce.date().nullable().optional(),
})

export type AddTeamMember = z.infer<typeof AddTeamMemberSchema>

export const UpdateTeamMemberSchema = z.object({
  isPrimary: z.boolean().optional(),
  startDate: z.coerce.date().nullable().optional(),
  endDate: z.coerce.date().nullable().optional(),
})

export type UpdateTeamMember = z.infer<typeof UpdateTeamMemberSchema>
